(function() {
'use strict';

angular.module('ekh').controller('EmiratesOffers', EmiratesOffers);

function EmiratesOffers(destinationService, cmsPageMapping, $routeParams, $window) {
    const cm = this;
    let route = '';
    cm.controls = {};
    cm.cmsItemsFound = true;


    cmsPageMapping.getOfferTypes().then(types => {
        const type = _.filter(types, type => {
            if ($routeParams.type != null) {
                route = $routeParams.type.replace('/', '');
            } else {
                route = $window.location.pathname.replace('?tm=1', '').substring(1);
            }
            return type.linkurl === route;
        })[0];

        if (type) {
            cm.controls.name = type.name;
            destinationService.getTiles({ ControlId: type.controlid }).then(components => {
                const componentsByType = (_.groupBy(components, 'controltype'));
                _.forEach(componentsByType, component => {
                    component.forEach(c => {
                        destinationService.getTiles({ ControlId: c.controlid }).then(tiles => {
                            cm.controls[c.controltype] = tiles;
                        });
                    });
                });
            });
        } else {
            cm.cmsItemsFound = false;
        }
    });
}
})();
